import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

// Global Types
import { AppState } from 'services/types';

// Global Actions
import {
    requestLoadSprayEventsForSubmission,
    resetSprayEventsForSubmission
} from 'services/sprayEventsForSubmission/actions';

// Global Selectors
import { selectLoadSprayEventsParams } from 'services/sprayEvents/params';

interface ConnectedProps {
    params?: ReturnType<typeof selectLoadSprayEventsParams>;
}

interface DispatchProps {
    requestLoadSprayEventsForSubmission: typeof requestLoadSprayEventsForSubmission;
    resetSprayEventsForSubmission: typeof resetSprayEventsForSubmission;
}

type Props = ConnectedProps & DispatchProps;

export class SprayEventsForSubmissionRequest extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { props } = this;
        props.requestLoadSprayEventsForSubmission();
    }

    componentDidUpdate(prevProps: Props): void {
        const { props } = this;
        if (!isEqual(prevProps.params, props.params)) {
            props.requestLoadSprayEventsForSubmission();
        }
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.resetSprayEventsForSubmission();
    }

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    params: selectLoadSprayEventsParams
});

export default connect(
    mapStateToProps,
    {
        requestLoadSprayEventsForSubmission,
        resetSprayEventsForSubmission
    }
)(SprayEventsForSubmissionRequest);
